import axios from "axios";
import Config from "../../Config";

const BASE_URL = `${Config.backendDomain}vendor`;

// Handles all vendor-facing order management API calls: paginated listing
// (with search/filter/sort query params), single order detail retrieval,
// and order status updates.
export class OrdersRequest {
  static getToken() {
    return localStorage.getItem("dealboxx_token");
  }

  static getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${OrdersRequest.getToken()}`,
      },
    };
  }

  static buildErrorMessage(error, fallback) {
    return (
      error?.response?.data?.data?.reason ||
      error?.response?.data?.message ||
      error?.message ||
      fallback
    );
  }

  // Fetches paginated vendor orders. Accepts: page, per_page, search,
  // status, fulfillment_type, purchase_type, sort_order, date_from, date_to.
  // Empty/undefined values are stripped so the backend only receives
  // params that are actually in use.
  static async getOrders(params = {}) {
    try {
      const cleanParams = Object.fromEntries(
        Object.entries(params).filter(
          ([, value]) => value !== undefined && value !== null && value !== ""
        )
      );

      const response = await axios.get(`${BASE_URL}/orders`, {
        ...OrdersRequest.getHeaders(),
        params: cleanParams,
      });

      return { success: true, data: response.data?.data };
    } catch (error) {
      return {
        success: false,
        message: OrdersRequest.buildErrorMessage(error, "Failed to fetch orders"),
      };
    }
  }

  static async getOrderDetails(orderCode) {
    try {
      const response = await axios.get(
        `${BASE_URL}/orders/${orderCode}`,
        OrdersRequest.getHeaders()
      );

      return { success: true, data: response.data?.data };
    } catch (error) {
      return {
        success: false,
        message: OrdersRequest.buildErrorMessage(error, "Failed to fetch order details"),
      };
    }
  }

  static async updateOrderStatus(orderCode, status) {
    try {
      const response = await axios.post(
        `${BASE_URL}/orders/${orderCode}/status`,
        { status },
        OrdersRequest.getHeaders()
      );

      return { success: true, data: response.data?.data };
    } catch (error) {
      return {
        success: false,
        message: OrdersRequest.buildErrorMessage(error, "Failed to update order status"),
      };
    }
  }
}

export default OrdersRequest;
